CHAT_BLOCKED_USERS_ENDPOINT